export default __webpack_public_path__ + "static/media/user.b9598092.png";